import React from 'react';
import { Form } from 'react-bootstrap';
import SearchableDropdown from './SearchableDropdown';

/**
 * Wrapper: ref + Form.Control + optional loading text + SearchableDropdown.
 * Use for "input that opens a dropdown of options" (search-as-you-type or select-only).
 */
const DropdownField = React.forwardRef(({
  value,
  onChange,
  placeholder,
  disabled,
  loading,
  loadingMessage = 'Loading...',
  showDropdown,
  options,
  emptyMessage,
  getLabel,
  getItemKey,
  onSelect,
  onFocus,
  onClick,
  id,
  name,
  size
}, ref) => (
  <div ref={ref} className="position-relative">
    <Form.Control
      type="text"
      name={name}
      autoComplete="off"
      value={value}
      onChange={onChange}
      readOnly={!onChange}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      onFocus={onFocus}
      onClick={onClick}
      aria-expanded={showDropdown}
      aria-controls={id}
    />
    {loading && <Form.Text className="text-muted">{loadingMessage}</Form.Text>}
    {showDropdown && !loading && (
      <SearchableDropdown
        options={options}
        emptyMessage={emptyMessage}
        onSelect={onSelect}
        getLabel={getLabel}
        id={id}
        getItemKey={getItemKey}
      />
    )}
  </div>
));

DropdownField.displayName = 'DropdownField';

export default DropdownField;
